export default __webpack_public_path__ + "static/media/edexcelhistory.2954ecf4.png";